import { atom } from "jotai";
import { moveAssetToCanvasFolderSetter } from "../canvas/canvasFolderAtom";
import { updateNodeSetter } from "../nodes";
import { saveCanvasSetter } from "../persistence";

export interface CreateAgentResponse {
  id: string;
  name: string;
  created_at: string;
  updated_at: string;
  is_deployed: boolean;
}

export const createNewAgentSetter = atom(
  null,
  async (_get, set, params: { nodeId: string; instructions?: string }) => {
    const { nodeId, instructions } = params;
    const name = "Untitled Agent";

    try {
      const response = await fetch("/api/canvasui/agents", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name, instructions }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.errors || "Failed to create agent");
      }

      const createdAgent = await response.json();

      // Update the node with the new agent ID
      const updatedNodes = set(updateNodeSetter, {
        id: nodeId,
        data: {
          agentId: createdAgent.id,
        },
      });

      // Save the canvas with the updated node
      set(saveCanvasSetter, { nodes: updatedNodes });

      set(moveAssetToCanvasFolderSetter, {
        assetType: "agent",
        assetId: createdAgent.id,
      });

      return createdAgent as CreateAgentResponse;
    } catch (error) {
      console.error("Error creating new agent:", error);
      // Propagate the error so that calling components can handle it.
      throw error;
    }
  },
);

createNewAgentSetter.debugLabel = "createNewAgentSetter";
